import { render, staticRenderFns } from "./course-detail.vue?vue&type=template&id=789bb509&scoped=true"
import script from "./course-detail.vue?vue&type=script&lang=js"
export * from "./course-detail.vue?vue&type=script&lang=js"
import style0 from "./course-detail.vue?vue&type=style&index=0&id=789bb509&prod&lang=scss&scoped=true"
import style1 from "./course-detail.vue?vue&type=style&index=1&id=789bb509&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789bb509",
  null
  
)

export default component.exports